// Supabase Connection Diagnostic Tool
import { createClient } from '@supabase/supabase-js';

// Test Supabase connection and configuration
export async function testSupabaseConnection() {
  console.log('🔍 Testing Supabase Connection...');
  
  // Check environment variables
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL ||
                      import.meta.env.REACT_APP_SUPABASE_URL ||
                      import.meta.env.NEXT_PUBLIC_SUPABASE_URL;
  
  const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY ||
                      import.meta.env.REACT_APP_SUPABASE_ANON_KEY ||
                      import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  console.log('Environment Variables Check:');
  console.log('- Supabase URL:', supabaseUrl ? '✅ Found' : '❌ Missing');
  console.log('- Supabase Key:', supabaseKey ? '✅ Found' : '❌ Missing');
  
  if (!supabaseUrl || !supabaseKey) {
    console.error('❌ Missing Supabase environment variables');
    return {
      success: false,
      error: 'Missing environment variables',
      details: {
        url: !!supabaseUrl,
        key: !!supabaseKey
      }
    };
  }

  try {
    // Create Supabase client
    const supabase = createClient(supabaseUrl, supabaseKey);
    console.log('✅ Supabase client created successfully');

    // Test basic connection by querying the 'profiles' table
    const { data, error } = await supabase
      .from('profiles')
      .select('id')
      .limit(1);

    if (error) {
      console.error('❌ Connection test failed:', error);
      return {
        success: false,
        error: 'Connection failed',
        details: error
      };
    }

    console.log('✅ Basic connection test passed');

    // Test authentication
    const { data: authData, error: authError } = await supabase.auth.getSession();
    
    if (authError) {
      console.error('❌ Auth test failed:', authError);
      return {
        success: false,
        error: 'Authentication test failed',
        details: authError
      };
    }

    console.log('✅ Authentication system accessible');
    console.log('Current session:', authData.session ? 'Active' : 'None');

    return {
      success: true,
      message: 'All tests passed',
      session: authData.session
    };

  } catch (error) {
    console.error('❌ Unexpected error:', error);
    return {
      success: false,
      error: 'Unexpected error',
      details: error.message
    };
  }
}

// Test function to be called from browser console
if (typeof window !== 'undefined') {
  window.testSupabase = testSupabaseConnection;
}
